"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeDataPointFromObj = void 0;
const utils_1 = require("ethers/lib/utils");
const DataPoint_1 = require("./DataPoint");
const NumericDataPoint_1 = require("./NumericDataPoint");
const deserializeDataPointFromObj = (plainObject) => {
    if (typeof plainObject.value == "number") {
        return new NumericDataPoint_1.NumericDataPoint(plainObject);
    }
    else {
        return new DataPoint_1.DataPoint(plainObject.dataFeedId, utils_1.base64.decode(plainObject.value), plainObject.metadata);
    }
};
exports.deserializeDataPointFromObj = deserializeDataPointFromObj;
//# sourceMappingURL=data-point-deserializer.js.map